import { useState } from 'react';
import { 
  FaCalendar, 
  FaUser, 
  FaStar, 
  FaComment,
  FaThumbsUp,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaLink
} from 'react-icons/fa';
import styles from './BlogDetail.module.css';

const BlogDetail = ({ post }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([
    {
      id: 1,
      user: "María García",
      avatar: "https://randomuser.me/api/portraits/women/1.jpg",
      comment: "Excelente artículo, muy informativo y bien estructurado.",
      date: "2024-01-15",
      likes: 12
    },
    // Add more comments as needed
  ]);

  const handleRating = (value) => {
    setRating(value);
  };

  const handleComment = (e) => {
    e.preventDefault();
    if (!comment.trim()) return;

    const newComment = {
      id: comments.length + 1,
      user: "Usuario Actual",
      avatar: "https://randomuser.me/api/portraits/lego/1.jpg",
      comment: comment,
      date: new Date().toISOString().split('T')[0],
      likes: 0
    };

    setComments([newComment, ...comments]);
    setComment('');
  };

  return (
    <article className={styles.blogDetail}>
      <div className={styles.heroSection}>
        <div className={styles.heroContent}>
          <span className={styles.category}>Desarrollo Web</span>
          <h1>Las Últimas Tendencias en Desarrollo Web 2024</h1>
          <div className={styles.metaInfo}>
            <div className={styles.metaItem}>
              <FaUser />
              <span>Por Carlos Martínez</span>
            </div>
            <div className={styles.metaItem}>
              <FaCalendar />
              <span>15 Enero 2024</span>
            </div>
            <div className={styles.metaItem}>
              <FaComment />
              <span>{comments.length} Comentarios</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.mainContent}>
          <div className={styles.featuredImage}>
            <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085" alt="Blog Featured" />
          </div>

          <div className={styles.articleContent}>
            {/* Article content goes here */}
            <p>Lorem ipsum dolor sit amet...</p>
          </div>

          <div className={styles.engagementSection}>
            <div className={styles.ratingSection}>
              <h3>¿Te resultó útil este artículo?</h3>
              <div className={styles.stars}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <FaStar
                    key={star}
                    className={`${styles.star} ${star <= rating ? styles.active : ''}`}
                    onClick={() => handleRating(star)}
                  />
                ))}
              </div>
            </div>

            <div className={styles.shareSection}>
              <h3>Comparte este artículo</h3>
              <div className={styles.socialButtons}>
                <button className={`${styles.socialButton} ${styles.facebook}`}>
                  <FaFacebook />
                </button>
                <button className={`${styles.socialButton} ${styles.twitter}`}>
                  <FaTwitter />
                </button>
                <button className={`${styles.socialButton} ${styles.linkedin}`}>
                  <FaLinkedin />
                </button>
                <button className={`${styles.socialButton} ${styles.link}`}>
                  <FaLink />
                </button>
              </div>
            </div>
          </div>

          <div className={styles.commentsSection}>
            <h2>Comentarios ({comments.length})</h2>
            
            <form onSubmit={handleComment} className={styles.commentForm}>
              <img src="https://randomuser.me/api/portraits/lego/1.jpg" alt="User Avatar" />
              <div className={styles.inputWrapper}>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Escribe tu comentario..."
                />
                <button type="submit">Comentar</button>
              </div>
            </form>

            <div className={styles.commentsList}>
              {comments.map((comment) => (
                <div key={comment.id} className={styles.commentCard}>
                  <img src={comment.avatar} alt={comment.user} />
                  <div className={styles.commentContent}>
                    <div className={styles.commentHeader}>
                      <h4>{comment.user}</h4>
                      <span>{comment.date}</span>
                    </div>
                    <p>{comment.comment}</p>
                    <div className={styles.commentActions}>
                      <button className={styles.likeButton}>
                        <FaThumbsUp />
                        <span>{comment.likes}</span>
                      </button>
                      <button className={styles.replyButton}>
                        Responder
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogDetail;